module.exports = __webpack_public_path__ + "static/media/MoyosoreoluwaOrekoya.79cfbfb0.jpg";